"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
var antd_1 = require("antd");
var config_provider_1 = require("antd/lib/config-provider");
var React = __importStar(require("react"));
var ResultProps_1 = require("./ResultProps");
var createResultProps_1 = require("./createResultProps");
var Result = function (props) {
    var _a, _b, _c, _d, _e;
    return (React.createElement(antd_1.Row, { align: "middle", justify: "center" },
        React.createElement(antd_1.Col, { xs: ((_a = props.cols) === null || _a === void 0 ? void 0 : _a.xs) || 24, sm: ((_b = props.cols) === null || _b === void 0 ? void 0 : _b.sm) || 20, md: ((_c = props.cols) === null || _c === void 0 ? void 0 : _c.md) || 20, lg: ((_d = props.cols) === null || _d === void 0 ? void 0 : _d.lg) || 16, xl: ((_e = props.cols) === null || _e === void 0 ? void 0 : _e.xl) || 12 },
            React.createElement(config_provider_1.ConfigConsumer, null, function (_a) {
                var locale = _a.locale;
                /* istanbul ignore next */
                var localeCode = locale && locale.locale ? locale.locale : "en";
                var resultProps = createResultProps_1.createResultProps(localeCode, props);
                return React.createElement(antd_1.Result, __assign({}, resultProps));
            }))));
};
exports.Result = Result;
// eslint-disable-next-line prefer-destructuring
Result.PRESENTED_IMAGE_403 = ResultProps_1.ExceptionMap[403];
// eslint-disable-next-line prefer-destructuring
Result.PRESENTED_IMAGE_404 = ResultProps_1.ExceptionMap[404];
// eslint-disable-next-line prefer-destructuring
Result.PRESENTED_IMAGE_500 = ResultProps_1.ExceptionMap[500];
//# sourceMappingURL=Result.js.map